// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".image-crop-modal {\n  z-index: 9999;\n}\n.image-crop-modal .kv-modal-body {\n  padding: 0 !important;\n}\n.image-crop-modal .kv-modal-body .image-content-wrapper {\n  height: 65vh;\n}", ""]);
// Exports
module.exports = exports;
